<template>
  <div class="Content_review">
    <el-form  style="padding:20px;background-color: #fff;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.Name" placeholder="请输入发布人，标题查询"></el-input>
      </el-form-item>
      <el-form-item label="内容形式">
        <el-select v-model="formInline.MaterialType" placeholder="请选择内容形式">
          <el-option label="文章" value="1"></el-option>
          <el-option label="视频" value="4"></el-option>
          <el-option label="音频" value="3"></el-option>
          <el-option label="图片" value="2"></el-option>
          <el-option label="公告" value="8"></el-option>
          <el-option label="轮播图" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="栏目">
        <el-cascader ref="wcascader" v-model="formInline.ItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择栏目"></el-cascader>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>
    </el-form>

    <div style="width: 100%;margin-top:16px;background-color: #fff;height: calc(100% - 120px);">
      <el-table :data="tableData" style="width: 98%;margin-left:1%;padding-top:16px;">
        <el-table-column prop="materialName" label="标题" ></el-table-column>
        <el-table-column prop="itemName" label="栏目"></el-table-column>
        <el-table-column prop="creator" label="发布人"></el-table-column>
        <el-table-column prop="materialType" label="内容形式"></el-table-column>
        <el-table-column prop="createdDate" label="创建时间"></el-table-column>
        <el-table-column prop="scheduledRelease" label="定时时间"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '6'">正在审核</span>
            <span v-if="scope.row.status == '3'">已驳回</span>
            <span v-if="scope.row.status == '2'">已通过</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">

            <span v-if="scope.row.status == '6'" style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" @click="examine(scope.row,1)">审核</span>
            <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" v-if="scope.row.status == '2' && (!scope.row.scheduledRelease || scope.row.scheduledRelease === null)" @click="re_publish(scope.row.materialKey)">发布</span>
            <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" v-if="scope.row.status == '2' && scope.row.scheduledRelease" @click="re_publish(scope.row.materialKey)">定时发布</span>
            <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row.materialKey,scope.row.materialType)">查看</span>

            <!-- 发布状态  1、已发布；2、已通过；3、已驳回；4、需修订；5、草稿；6、正在审核  -->
            <!-- <span v-if="scope.row.materialType=='文章'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Preview(scope.row.materialKey)">预览</span> -->
            <span v-if="scope.row.status == '2'" style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" @click="examine(scope.row,2)">修改</span>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="formInline.pageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
    </div>

    <el-dialog :visible.sync="Articledialog" width="640px" top="10vh" :before-close="handleClose">
      <div class="Articlecontent">
        <div v-html="Article"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bhyy:'',
      fileList: [],
      filedata: [],
      formInline: {
        PageSize: 10,
        PageIndex: 1,
        MaterialType:"",//内容形式
        Name:""	,//标题、发布人查询
        ItemKey: "",//栏目
        time:'',
        StartTime:"",//开始时间
        EndTime:""//结束时间
      },
      data: [],
      tableData: [],
      UndoCount:1,
      te:{},
      Articledialog:false,
      Article:'',
    }
  },
  activated(){
    this.loading();
  },
  methods: {
    handleRemove(file, fileList) {
      if(this.filedata.length <=1){
        this.filedata = []
      }else{
        for(var i = 0;i < this.filedata.length;i++){
          if(file.name == this.filedata[i].name){
            this.filedata.splice(i,1)
          }
        }
      }
      this.fileList = fileList
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    handleChange(file, fileList){
      this.fileList.push({
        name:file.name,
        url:file.url
      })
      this.filedata.push(file)
    },
    resetfun() {
      this.formInline = {
        PageSize: 10,
        PageIndex: 1,
        MaterialType: "",//内容形式
        Name: "",//标题、发布人查询
        ItemKey: "",//栏目
        time: '',
        StartTime: "",//开始时间
        EndTime: ""//结束时间
      }
      this.loading();
    },
    handleCurrentChange(val) {
      this.formInline.PageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.formInline.PageIndex = 1;
      this.loading();
    },
    examine(row,type) {//type 0代表查看，1代表审核
      if (row.materialType == '音频') {
        this.$router.push({
          path: '/propagate/Audio_release',
          query: { materialKey: row.materialKey,type:type },
        })
      } else if (row.materialType == '视频') {
        this.$router.push({
          path: '/propagate/Video_release',
          query: { materialKey: row.materialKey,type:type },
        })
      } else if (row.materialType == '图片') {
        this.$router.push({
          path: '/propagate/Picture_edit',
          query: { materialKey: row.materialKey,type:type },
        })
      }else if (row.materialType == "文章") {
        this.$router.push({
          path: '/propagate/Article_release',
          query: { materialKey: row.materialKey,type:type },
        })
      }else if (row.materialType == "公告") {
        this.$router.push({
          path: '/propagate/Article_releases',
          query: { materialKey: row.materialKey,type:type },
        })
      }else if (row.materialType == "轮播图") {
        this.$router.push({
          path: '/propagate/Carousel_release',
          query: { materialKey: row.materialKey,type:type },
        })
      }

    },
    // 预览
    Preview(materialKey){
      this.$Http_Post('management/getContentDetails',{MaterialKey:materialKey}).then(res=>{
        if(res.Code==200 || res.Code==0){
          this.Articledialog = true;
          this.Article = res.Data.richTextContent;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      });
    },
    re_publish(materialKey) {//发布
      this.$Http_Post('management/contentPublishOperate', {MaterialKey:materialKey,Type:1}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    re_look(materialKey, materialType) {//查看
      if (materialType == "音频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 1 ,Source: 2 },
        })
      } else if (materialType == "视频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 2 , Source: 2 },
        })
      } else if (materialType == "图片") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 3 , Source: 2 },
        })
      }else if(materialType == "文章"){
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 4 , Source: 7 ,status:status},
        })
      }else if(materialType == "公告"){
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 4 , Source: 7},
        })
      }else if(materialType == "轮播图"){
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 5 , Source: 0},
        })
      }
    },
    loading() {
      this.$Http_Post('management/contentExamine', {
        MaterialType: this.formInline.MaterialType,
        Name: this.formInline.Name,
        ItemKey: this.formInline.ItemKey,
        PageSize: this.formInline.PageSize,
        PageIndex: this.formInline.PageIndex,
        StartTime: this.formInline.time[0],
        EndTime: this.formInline.time[1],
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    Selected_to_shut_dow(dt) {
      this.formInline.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break;
        }
      }
      return obj
    },
    bumen(dt) {

      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }

      

    },
  },
  mounted() {
    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.loading();
  },
}
</script>
<style>
.Content_review{width: 100%;height: 100%;}
</style>
